<div class="signup-container">
  <div class="top">
    <h3 i18n>Sign Up For Free To Get Started</h3>
  </div>
  <div class="content">
    <div class="hide-for-offroad" i18n>Get started with your free RIDE COMMAND® account now.</div>
    <div class="hide-for-motorcycle">
      <span class="hide-tiny" i18n>Revolutionize your snow and off-road experience! </span>
      <span i18n>Get started with your free RIDE COMMAND® account now.</span>
    </div>

    <form #signUpForm="ngForm" id="signUpForm" name="signUpForm" (submit)="onSignupClicked()">
      <mat-form-field class="helper-full-width">
        <mat-label i18n>Email</mat-label>
        <input
          #signUpEmail="ngModel"
          id="signUpEmail"
          name="signUpEmail"
          matInput
          required
          [(ngModel)]="userEmail"
          (keyup.enter)="onSignupClicked()"
        />
        @if (signUpEmail.invalid && (signUpEmail.dirty || signUpEmail.touched)) {
          <mat-error i18n>An email is required.</mat-error>
        }
      </mat-form-field>
      <div>
        <button id="signupNext" class="button primary-button helper-full-width" type="submit" i18n>Next</button>
      </div>
    </form>
    <div class="helper-align-center has-account-text">
      <span i18n>Already have an account?</span>
      <a id="logInLink" href="javascript:void(0)" rdcAnalytics="Login" (click)="onSigninClicked()" i18n>Log in now.</a>
    </div>
  </div>
</div>
